export default __webpack_public_path__ + "static/media/c(3).2bfdb5bb.jpg";